import { render, staticRenderFns } from "./PastagemEua2007.vue?vue&type=template&id=3377fada&lang=pug"
import script from "./PastagemEua2007.vue?vue&type=script&lang=js"
export * from "./PastagemEua2007.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports